import Store from 'store/store';

Store.on('ADD_TILED_ITEMS_FOOTER_SHADOW', (bool) => {
	if (!Store.get().tiledItems) {
		Store.get().set({ tiledItems: {} });
	}
	Store.get().tiledItems.set({ addShadowToFooter: bool });
});